import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";


//Flags
import SouthAfrica from "./assets/south-africa.png";
import America from "./assets/america.png";
import Nigeria from "./assets/nigeria.png";
import Kenya from "./assets/kenya.png";

const Crypto = createContext();

const CryptoContext = ({ children }) => {

    //Set Flag and Currency
    const [currency, setCurrency] = useState('USD');
    const [symbol, setSymbol] = useState("$");
    const [flag, setFlag] = useState(America);
    const stateCurrency = window.localStorage.getItem('CURRENCY_STATE');

    //API endpoint for getting live currency exchanges
    const dollar = 1;
    const [amountBasedOnDollar, setAmountBasedOnDollar] = useState(dollar);
    const [randExchange, setRandExchange] = useState();
    const [nairaExchange, setNairaExchange] = useState();
    const [shillingExchange, setShillingExchange] = useState();



    const BASE_URL = "https://api.apilayer.com/exchangerates_data/latest?symbols=ZAR%2CNGN%2CKES&base=USD&apikey=c5lHwJBhDTwsWSohVu8B7jGm0t1niISv";
    //const BASE_URL = "https://api.apilayer.com/exchangerates_data/latest?symbols=ZAR%2CNGN%2CKES&base=USD&apikey=WJeF6l6p565QF55l8qf74xtekjBbDAxf";


    //Sort the initial state of currency when App is launched
    useEffect(() => {

        fetch(BASE_URL)
            .then(res => res.json())
            .then(data => {
                const rand = Object.keys(data.rates)[0]
                const naira = Object.keys(data.rates)[1]
                const shilling = Object.keys(data.rates)[2]
                setRandExchange(data.rates[rand])
                setNairaExchange(data.rates[naira])
                setShillingExchange(data.rates[shilling])
            })

        //Get Currency state when launching the app
        //window.localStorage.setItem('CURRENCY_STATE', JSON.stringify(currency));
        //setCurrency(JSON.parse(stateCurrency));

        //console.log(stateCurrency);

    }, [])


    //Change the state of currency, flag and symbol based on user's input

    useEffect(() => {

        //Update Currency when user changes currency
        //window.localStorage.setItem('CURRENCY_STATE', JSON.stringify(currency));


        //Change Currency
        if (currency === "ZAR") setSymbol("R");
        else if (currency === "USD") setSymbol("$");
        else if (currency === "NGN") setSymbol("₦");
        else if (currency === "KES") setSymbol("K");

        //Change Country Flag
        if (currency === "ZAR") setFlag(SouthAfrica);
        else if (currency === "USD") setFlag(America);
        else if (currency === "NGN") setFlag(Nigeria);
        else if (currency === "KES") setFlag(Kenya);

    }, [currency]);

    //Update Amounts Based On Live Exchange Rate Received From API

    useEffect(() => {

        if (currency === "USD") setAmountBasedOnDollar(dollar);
        else if (currency === "ZAR") setAmountBasedOnDollar(randExchange);
        else if (currency === "NGN") setAmountBasedOnDollar(nairaExchange);
        else if (currency === "KES") setAmountBasedOnDollar(shillingExchange);

    }, [currency]);


    //Get user Location
    const [currLocation, setCurrLocation] = useState({});
    const [currLocationJs, setCurrLocationJs] = useState({});
    useEffect(() => {
        getLocation();
        getLocationJs();
    }, []);

    const getLocation = async () => {
        const location = await axios.get("https://ipapi.co/json");
        setCurrLocation(location.data);
    };

    const getLocationJs = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            setCurrLocationJs({ latitude, longitude });
        });
    };

    const country = [currLocation.country_name];
    const city = [currLocation.city];

    //End Get user Location

    //User's Fiat Wallet Balance
    const cashWallet = 5638.98;
    const cashWalletConverted = amountBasedOnDollar * cashWallet;
    //End user's Fiat Wallet Balance


    return (
        <Crypto.Provider value={{
            currency, setCurrency, symbol, flag,
            amountBasedOnDollar, setAmountBasedOnDollar, randExchange, nairaExchange, shillingExchange,
            country, city, cashWalletConverted
        }}>
            {children}
        </Crypto.Provider>
    );
};

export default CryptoContext;

export const CurrencyState = () => {
    return useContext(Crypto);
};
